module.exports = __webpack_public_path__ + "ae708ee1560ab8a9748b365c653453a0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp6.jpeg
// module id = 1140
// module chunks = 0